// Router paths
export const DISCOUNT_CODES = '/discount_codes';
export const PAYMENTS = '/payments';
export const EXPORT = '/export';
export const CUSTOM_PERIOD = '/custom_period';
export const BUY = '/buy';
export const INTERNAL_STATISTICS = '/internal_statistics';
